import { createTheme } from "@mui/material/styles";

export const getApiBaseEndPoint = () => {
    const sessionConfig = localStorage.getItem("config");
    if (sessionConfig === null) {
        console.log("App settings (msal) are not loaded into the session store yet!");
        return "";
    }

    const appSettings = JSON.parse(sessionConfig);
    const protectedResources = appSettings?.protectedResources;    
    return protectedResources?.LeaseService?.baseEndPoint;
}
export const baseUrl = getApiBaseEndPoint();
export const theme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 767,
        md: 1000,
        lg: 1700,
        xl: 2000,
      },
    },
  });